<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'
    export default {
        data() {
            return {
                crudName: 'Empresas',
                newText: 'Cadastrar Empresa',
                table: 'companiesTable',
                columns: ['id', 'corporate_name', 'fantasy_name', 'actions'],
                tableData: ['id', 'name', 'type_id', 'category_id'],
                options: {
                    filterByColumn: true,
                    debounce: 1000,
                    sortable: ['id', 'corporate_name', 'fantasy_name'],
                    filterable: ['id', 'corporate_name', 'fantasy_name'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': '#',
                        'corporate_name' : 'Razão Social',
                        'fantasy_name' : 'Nome Fantasia',
                        'actions' : 'Ações'
                    },
                    templates: {},
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }
                },
                endPoint: 'companies/',
                dataForm: {
                  title: {
                    add: 'Nova Empresa',
                    edit: 'Editar Empresa',
                    view: 'Visualizar Empresa',
                    icon: 'fa fa-pen'
                  },
                  button: {
                    back: '/companies'
                  },
                  url: {
                    model: 'companies'
                  },
                  messages: {
                    success: {
                      add: 'Empresa cadastrado com sucesso!',
                      edit: 'Empresa alterado com sucesso!'
                    }
                  },
                  fields: [
                    {
                      name: 'corporate_name',
                      model: 'corporate_name',
                      label: 'Nome',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|6",
                      offset: null
                    },
                    {
                      name: 'fantasy_name',
                      model: 'fantasy_name',
                      label: 'Nome Fantasia',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|6",
                      offset: null
                    },
                    {
                      name: 'cnpj',
                      model: 'cnpj',
                      label: 'CNPJ',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|6",
                      offset: null,
                      mask:"##.###.###/####-##"
                    },
                    {
                      name: 'email',
                      model: 'email',
                      label: 'E-mail',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|6",
                      offset: null
                    },
                    {
                      name: 'cep',
                      model: 'cep',
                      label: 'CEP',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|3",
                      offset: null,
                      mask:"##.###-###"
                    },
                    {
                      name: 'adress',
                      model: 'adress',
                      label: 'Endereço',
                      type: 'text',
                      isRequired: {
                        add: true,
                        edit: true,
                      },
                      placeholder: '',
                      class: '',
                      length: "12|6|9",
                      offset: null
                    }
                  ]
                }
            }
        },
        methods: {
            query: function (query) {
                let columns = {
                    id: 'id',
                    corporate_name: 'corporate_name',
                    fantasy_name: 'fantasy_name'
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                return filters;
            },
        },
        components: {
            BaseCrud
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Company/Crud.vue